<div class="ov" role="dialog" aria-modal="true" aria-labelledby="ov-title" [attr.aria-busy]="isRunning()">

    <div aria-hidden="true" class="ov-glow"></div>

    <div class="ov-stage" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">

        @if (isRunning()) {

        <div class="ov-scan" aria-hidden="true">
            <span class="ring"></span>
            @switch (headIcon()) {
            @case ('send') {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
                <path d="m21.854 2.147-10.94 10.939" />
            </svg>
            }
            @default {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m22 22-5.5-5.5" />
                <path d="M3 11a8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8Z" />
                <path d="M8 11h6" />
            </svg>
            }
            }
        </div>

        <h2 id="ov-title" class="ov-title">{{ headline() }}</h2>
        <p class="ov-sub">{{ subLead() }} <b>{{ subject() }}</b> {{ subTrail() }}</p>

        <ul class="ov-steps" role="status" aria-live="polite">
            @for (stage of stages(); track stage; let i = $index) {
            <li class="ov-step" [class.active]="i === activeStage()" [class.done]="i < activeStage()">
                <span class="ov-si" aria-hidden="true">
                    <span class="ring"></span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="ov-check">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                </span>
                <span class="ov-lbl">{{ stage }}</span>
            </li>
            }
        </ul>

        } @else {

        <div class="ov-result" role="status" aria-live="polite">

            <div class="ov-badge" [class.ov-badge--pass]="result() === 'pass'"
                [class.ov-badge--fail]="result() === 'fail'" aria-hidden="true">
                @if (result() === 'pass') {
                @if (passIcon() === 'check-check') {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 6 7 17l-5-5" />
                    <path d="m22 10-7.5 7.5L13 16" />
                </svg>
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                }
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                    <path d="M12 9v4" />
                    <path d="M12 17h.01" />
                </svg>
                }
            </div>

            <h2 id="ov-title" class="ov-title">{{ resultTitle() }}</h2>
            <p class="ov-sub">{{ resultSub() }}</p>

            @if (reasons().length) {
            <ul class="ov-reasons">
                @for (reason of reasons(); track reason) {
                <li class="ov-reason">
                    <span class="ov-dot" aria-hidden="true"></span>
                    {{ reason }}
                </li>
                }
            </ul>
            }
        </div>

        <div class="ov-actions">
            <ng-content select="[overlayActions]" />
        </div>

        }
    </div>
</div>
